import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container mx-auto kho-form-wrapper" }
const _hoisted_2 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_3 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_4 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_5 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_6 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_7 = { class: "flex justify-center mt-3 gap-x-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DivCol = _resolveComponent("DivCol")!
  const _component_DivRow = _resolveComponent("DivRow")!
  const _component_TaiKhoanSelectionV2 = _resolveComponent("TaiKhoanSelectionV2")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createBlock(_component_PageContentBase, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DivRow, { class: "mb-3 g-3" }, {
              default: _withCtx(() => [
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 2
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_LabelCustom, { "is-required": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Tên kho")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "mb-0 w-full",
                        error: _ctx.nameErrorMess
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            ref: "tenKhoInputRef",
                            modelValue: _ctx.name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                            placeholder: "Tên kho",
                            name: "name",
                            onFocus: _cache[1] || (_cache[1] = ($event: any) => ($event.target.select()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["error"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 2
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_LabelCustom, { "is-required": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Mã kho")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { class: "mb-0 w-full" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.code,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.code) = $event)),
                            placeholder: "Mã kho",
                            name: "code",
                            disabled: "",
                            onFocus: _cache[3] || (_cache[3] = ($event: any) => ($event.target.select()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 4
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_LabelCustom, { "is-required": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Địa chỉ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "mb-0 w-full",
                        error: _ctx.addressErrorMess
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.address,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.address) = $event)),
                            placeholder: "Địa chỉ",
                            name: "address",
                            onFocus: _cache[5] || (_cache[5] = ($event: any) => ($event.target.select()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["error"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 4
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Ghi chú kho")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { class: "mb-0 w-full" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.note,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.note) = $event)),
                            placeholder: "Ghi chú",
                            name: "note",
                            onFocus: _cache[7] || (_cache[7] = ($event: any) => ($event.target.select()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_DivRow, { class: "mb-3" }, {
              default: _withCtx(() => [
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 12
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Tài khoản")
                        ]),
                        _: 1
                      }),
                      (_ctx.isWarehouseLoaded)
                        ? (_openBlock(), _createBlock(_component_TaiKhoanSelectionV2, {
                            key: 0,
                            class: "w-100",
                            "ma-tai-khoan-prop": _ctx.taiKhoanData.maTaiKhoan,
                            "ma-chi-tiet-prop": _ctx.taiKhoanData.maChiTiet,
                            "ten-tai-khoan-prop": _ctx.taiKhoanData.tenTaiKhoan,
                            onOnSelect: _ctx.onSelectTaiKhoan
                          }, null, 8, ["ma-tai-khoan-prop", "ma-chi-tiet-prop", "ten-tai-khoan-prop", "onOnSelect"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ButtonCustom, {
                classes: `rounded-none m-0`,
                "button-type": _ctx.ButtonsType.SAVE,
                "color-type": _ctx.ButtonTypeColors.SUCCESS,
                type: _ctx.ButtonTypes.BUTTON,
                onClick: _ctx.onSubmit
              }, {
                "button-label": _withCtx(() => [
                  _createTextVNode("Lưu")
                ]),
                _: 1
              }, 8, ["button-type", "color-type", "type", "onClick"])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ]),
    _: 1
  }))
}